//  Componente stateless per visualizzazione messaggi di errore in form
import React from 'react';
import {PropTypes} from 'prop-types';

const FieldErrors = (props) => {
  if(props.errors.length > 0) {
    return(
      <div>
        {props.errors.map((errorMessage, idx) => (<p key={idx} className="text-validation">{errorMessage}</p>))}
      </div>
    );
  } else {
    return (null);
  }
};

FieldErrors.defaultProps = {
  errors: []
};

FieldErrors.propTypes = {
  errors: PropTypes.array
};

export default FieldErrors;